// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {findMatchingKey} from '../../../claim/shared/services/claim-shared-helper';
import {getDebit} from '../../shared/repositories';
import {updateConfirmationModalVisibility} from './confirmation-modal';
import {updateFullDebitModalVisibility} from './claim-debit';

export const readDebit = (claimNumber, debitType, debitTypes) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const debit = await getDebit(claimNumber);

            dispatch({
                debit,
                type: actions.UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_ITEM
            });

            dispatch({
                debitType: findMatchingKey(debitType, debitTypes),
                type: actions.UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_TYPE
            });

            debit.isDebitFormRequired ?
                updateConfirmationModalVisibility(true)(dispatch) :
                updateFullDebitModalVisibility(true)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/action-creators/get-debit.js